var _path, _path2, _path3, _circle, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJmhzRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M33.583 12.263v9.82H9.723v-11.36c0-3.14 2.54-5.68 5.68-5.68h11.02l7.16 7.22z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M25.542 6.383v6.733h7.11"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M5.673 32.907h3.656M5.673 27.509h3.656M33.19 27.509h3.657M5.673 22.111h31.174"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 35.019,
    cy: 32.907,
    r: 1.441
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M16.209 31.967l4.217 3.821 7.278-8.279"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJmhzRegular);
export default __webpack_public_path__ + "static/media/JMHZ-regular.998b461161faa53b1404e19bf1f9f99a.svg";
export { ForwardRef as ReactComponent };